import { Box } from "@mui/material";

export default function PageContainer({ children }) {
  return (
    <Box sx={{ p: 3, maxWidth: 900, mx: "auto", mt: { xs: 9, sm: 10 } }}>
      {children}
    </Box>
  );
}